var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"isOpen":_vm.isOpen,"heading":"File Errors","subHeading":"Import Player List"},on:{"onClose":_vm.onClose},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('Button',{on:{"onClick":_vm.downloadErrors}},[_vm._v("Save")])]},proxy:true}])},[_c('ErrorsTable',_vm._b({},'ErrorsTable',{errors: _vm.errors},false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }